import type { RefOrGetter } from "ls/common/types";
import type { RouteLocationRaw } from "vue-router";
import { useIsEmbed } from "ls/composables/useIsEmbed";
import { useDiagramObject } from "ls/features/disko/queries/diagram";
import { toFileOverview } from "ls/router/builders";
import { computed, toValue } from "vue";
import { useLink } from "vue-router";

export function useEditorCanvasLink(shortcut: RefOrGetter<string>, objectId: RefOrGetter<string>) {
  const diagramObject = useDiagramObject(objectId);
  const isEmbed = useIsEmbed();
  const isPending = computed(() => diagramObject.isPending.value);
  const isPresent = computed(() => {
    if (isPending.value) return undefined;
    if (diagramObject.status.value === "success" && !!diagramObject.data.value) return true;
    return false;
  });

  const resolvedCanvasRoute = computed(() => {
    const location: RouteLocationRaw = {
      ...toFileOverview(toValue(shortcut), { object: toValue(objectId), embed: isEmbed.value }),
      force: true,
      replace: true,
    };

    return location;
  });

  const { href, navigate } = useLink({
    to: resolvedCanvasRoute,
  });

  const objectName = computed(() => diagramObject.data.value?.name);
  const text = computed(() => {
    if (isPending.value) return "Canvas";
    if (isPresent.value === false) return "Canvas link";
    return objectName.value ?? "";
  });

  return {
    href,
    text,
    isPending,
    isPresent,
    navigate,
  };
}
